import { Component } from 'react';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import InfoMessage from '../InfoMessage/InfoMessage';
import SuccessMessage from '../SuccessMessage/SuccessMessage';
import WarningMessage from '../WarningMessage/WarningMessage';

export default class GlobalMessage extends Component{
    constructor(props){
        super(props);
        // console.table(props);
        // console.table(props.message);
        // console.table(props.message.message["ndgm-danger"]);
    }

    render(){
        let error, success, warn, info

        if(this.props.message.message["ndgm-danger"].length > 0){
            error = <ErrorMessage error={this.props.message.message["ndgm-danger"]}/>
        }
        if(this.props.message.message["ndgm-info"].length > 0){
            info = <InfoMessage info={this.props.message.message["ndgm-info"]}/>
        }
        if(this.props.message.message["ndgm-warn"].length > 0){
            warn = <WarningMessage warn={this.props.message.message["ndgm-warn"]}/>
        }
        if(this.props.message.message["ndgm-success"].length > 0){
            success = <SuccessMessage success={this.props.message.message["ndgm-success"]}/>
        }
        return(
            <>
                {error}
                {info}
                {warn}
                {success}
            </>
        )
    }

}